<template>
  <el-form class="egl-elm egl-detail setting" :model="fees">
    <el-row :gutter="10">
      <el-col :span="20">
        <el-row :gutter="10">
          <el-col :span="10">
            <el-form-item :label="$locale('setting.pay.fee.amount')+(control.addable?control.count+1:'')" 
            :rules="[{ required: true, trigger: 'blur', }]">
              <el-input v-model="fees.amount" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item >
              <span slot="label"><img /></span>
              <el-select v-model="fees.unit" >
                <el-option
                  v-for="item in unitIndex"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$locale('setting.pay.fee.transmethod')+(control.addable?control.count+1:'')+$locale('setting.pay.fee.transmethod.suffix')">
              <template v-if="control.fixMethod">
              <el-select v-model="fees.method" disabled>
                <el-option
                  v-for="item in modidx"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
              </template>
              <template v-else>
              <el-select v-model="fees.method" >
                <el-option
                  v-for="item in modidx"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$locale('setting.pay.fee.tax')">
              <TaxSelect v-model="fees.taxRate"></TaxSelect>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item :label="$locale('setting.pay.fee.client')">
              <!-- <el-select v-model="fees.client" filterable>
                <el-option 
                  v-for="item in cl"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select> -->
              <remote-select
                  type="client"
                  :isMultiple="false"
                  v-model="fees.client"
                  :formValue.sync="fees.client"
                  :actionType="!$attrs.isUpdate ? 'create' : 'edit'"
                ></remote-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="type == 'gmo'">
          <el-col :span="7">
            <el-form-item :label="$locale('setting.pay.fee.destcode')">
              <el-input v-model="fees.code" ></el-input> 
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="type == 'creditCard3000'">
          <el-col :span="7">
            <el-form-item :label="$locale('setting.pay.fee.destcode2')">
              <el-input v-model="fees.code" ></el-input> 
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$locale('bookKeeping.account')">
              <el-select v-model="fees.bookEntry">
                <el-option v-for="n in jl"
                :key="n.id"
                :value="n.id"
                :label="n.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$locale('bookKeeping.entry1')">
              <el-input v-model="fees.entry1" placeholder="A123" @input.native="handleEntry1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$locale('bookKeeping.entry2')">
              <el-input v-model="fees.entry2" placeholder="A123"  @input.native="handleEntry2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" :style="{ 'display':'flex'}" v-if="control.addable">
        <div class="operation" v-if="total > 1"
        @click="decFee(control.count)" >
          <i class="el-icon-minus"></i>
        </div>
        <div class="operation" v-if="control.count == (total-1)" 
        @click="incFee"> 
          <i class="el-icon-plus"></i>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import "@/assets/style/paymentManagement.less";
import TaxSelect from "@/components/common/TaxSelect";
import RemoteSelect from "@/components/common/RemoteSelect";

export default {
  components: {
    TaxSelect,
    RemoteSelect,
  },
  props: {
    total : {    
      type: Number,
      default : 0,
    },
    type: '',
    control : {},
    cl:{},
    jl : {
      type: Array,
      default:[],
    },
  },
  data() {
    return {
      fees : {
        amount: this.control.amount || 0,
        unit: this.control.unit || 'percent',
        method: this.control.method || 'single',
        taxRate: this.control.taxRate || 0.1,
        client: this.control.client || '',
        code: this.control.code || '',
        type: this.type,
        bookEntry: this.control.bookEntry || '',
        entry1 : this.control.entry1 || '',
        entry2 : this.control.entry2 || '',
      },
      unitIndex: [
        {
          label: "%",
          value: 'percent'
        },
        {
          label: this.$locale('global.yen.text'),
          value: 'yen'
        },
      ],
      modidx : [
        {
          label: this.$locale('setting.pay.mod.single'),
          value: 'single',
        },
        {
          label: this.$locale('setting.pay.mod.month'),
          value: 'month',
        }
      ],
    }
  },

  mounted() {
    this.fees = this.control
  },

  methods: {
    handleEntry1(e) {
      let val = e.target.value
      this.$emit('entry1', this.control.count, val)

    },
    handleEntry2(e) {
      let val = e.target.value
      this.$emit('entry2', this.control.count, val)
    },
    incFee () {
      this.$emit("add")
    },
    decFee (idx) {
      this.$emit("del", idx)
    },
    getData() {
      return {
        amount: (parseFloat(this.fees.amount) == NaN) ? 0:parseFloat(this.fees.amount),
        unit: this.fees.unit, 
        method:this.fees.method,
        taxRate: this.fees.taxRate, 
        client: this.fees.client,
        code: this.fees.code,
        bookEntry: this.fees.bookEntry || '',
        entry1 : this.fees.entry1 || '',
        entry2 : this.fees.entry2 || '',
      }
    }
  }

};
</script>